import { HOST_URL } from '../../config'
import { HttpStatus } from '../../constants/http-status.enum'
import type { ApiResponse } from '../index'
import type { IClientUID } from '../clients'

export enum PeripheralType {
    RelSol1 = 1,
    RelSol2 = 2,
    RelSol3 = 3,
    RelSol4 = 4,
    RelSol5 = 5,
    RelSol6 = 6,
    RelSol7 = 7,
    RelSol8 = 8,
}
export interface IPeripheralUpdate {
    type: PeripheralType
    state: boolean
}
export async function updateClientPeripherals(clientId: IClientUID, update: IPeripheralUpdate): Promise<ApiResponse<void>> {
    const response = await fetch(`${HOST_URL}peripheral`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId, ...update }),
    })
    const result = (await response.json()) as any
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
